import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export function successNoti(message) {
    if (message === undefined) {
        toast.error('Success/Failure message not found.');
    }
    else {
        toast.success('Success: ' + message ? message : "Operation performed successfully.");
    }
}

export function errorNoti(message) {
    if (message === undefined) {
        toast.error('Success/Failure message not found.');
    }
    else {
        toast.error('Error: ' + message ? message : "Something went wrong, please try again.");
    }
}